export const animationBattle = {
  keyframes: [
    {
      scale: 0.3,
    },
    {
      scale: 1.1,
    },
    {
      scale: 1,
      opacity: 1,
    },
  ],
  easing: "linear",
  duration: 1000,
  loop: false,
};
